import { render, staticRenderFns } from "./IntegrationCountries.vue?vue&type=template&id=b860e224"
import script from "./IntegrationCountries.vue?vue&type=script&lang=js"
export * from "./IntegrationCountries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports